import { motion } from "framer-motion";
import * as React from "react";
import { useNavigate } from "react-router-dom";

function Header(props) {
  const navigate = useNavigate();
  return (
    <motion.div className="flex flex-col items-center self-stretch px-5 pb-5 w-full bg-dark-indigo max-md:max-w-full"
      initial={{ opacity: 0, scale: 0.5 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
      viewport={{ once: true }} 
    >
      <div className="container min-h-[200px]">
        <div className="mt-9 text-2xl sm:text-4xl font-medium leading-10 text-center text-white capitalize max-md:max-w-full">
          {props.title}
        </div>
        <div className="mt-5 text-[20px] text-center text-white w-full max-w-[870px] mx-auto">
          {props.description}
        </div>
        <div className="my-3 flex justify-center">
          <button
          className="justify-center px-16 py-5 mt-14 text-2xl text-center text-white rounded-lg  shadow-xl max-md:px-6 max-md:mt-10 dark-button"
            onClick={props.onClick}
          >
            { props.buttonText}
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default Header;
